import { appStoreLenses } from 'root/src/client/logic/app/lenses'

const { viewCcv } = appStoreLenses

export default viewCcv
